<template>
  <v-card
    elevation="6"
    class="d-flex justify-space-between pa-4 rounded-lg"
    :class="validateOrganization ? 'flex-column' : 'align-center'"
    style="height: 100%"
  >
    <div class="d-flex align-center">
      <v-avatar :size="$vuetify.breakpoint.smAndDown ? 60 : 100">
        <v-img
          v-if="imageSource"
          :src="imageSource"
          fit
          alt="benefit_image"
          @error="handleImageError"
        />
        <div v-else style="background-color: #d8d8d8; width: 100%; height: 100%;">
          <v-icon size="30">mdi-ticket</v-icon>
        </div>
      </v-avatar>
      <div class="overflow-y-auto mx-4">
        <h3 :class="!$vuetify.breakpoint.smAndDown || 'benefit_title-sm'">{{ name }}</h3>
        <p
          class="ma-0"
          :class="$vuetify.breakpoint.smAndDown ? 'benefit_description-sm' : 'benefit_description'"
          style="width: 100%; word-break: break-word"
        >
          {{ description }}
        </p>
      </div>
    </div>
    <div id="actions" class="d-flex justify-end" v-if="validateOrganization">
      <v-btn
        x-small
        @click="handleEdit()"
        elevation="0"
        class="white--text text-capitalize rounded-pill"
        fab
        :color="color.primaryVariant"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        x-small
        elevation="0"
        @click="handleDelete()"
        class="white--text text-capitalize rounded-pill ml-4"
        fab
        color="red"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>
    <div
      v-else-if="!validateOrganization && (url || api)"
      id="actions"
      class="d-flex justify-center"
    >
      <v-menu offset-y top open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-on="on"
            v-bind="attrs"
            fab
            x-small
            elevation="0"
            color="#35404c"
            class="white--text"
            :disabled="user.validationStatus !== 'ACTIVE'"
            @click="benefitType === 'api' ? $handleApi() : openLink(url)"
          >
            <v-icon> mdi-link-variant </v-icon></v-btn
          >
        </template>
        <v-sheet color="#fffaf8" class="pa-2" style="font-size: 14px; font-weight: 500">
          Adquiere tu beneficio!
        </v-sheet>
      </v-menu>
    </div>
  </v-card>
</template>
<script>
import { colors } from '@/constants/colors.js';
import { mapState } from 'vuex';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
    },
    fallbackImage: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    expiredDate: {
      type: Date,
    },
    url: {
      type: String,
      default: '',
    },
    api: {
      type: Function,
      required: false,
      default: null
    },
    benefitType: {
      type: "direct" | "api",
      default: "direct",
    },
  },
  data() {
    return {
      color: colors,
      imageFailed: false,
      fallbackFailed: false,
    };
  },
  watch: {
    icon() {
      this.imageFailed = false;
      this.fallbackFailed = false;
    },
    fallbackImage() {
      this.imageFailed = false;
      this.fallbackFailed = false;
    },
  },
  methods: {
    handleImageError() {
      if (this.icon && !this.imageFailed) {
        this.imageFailed = true;
      } else {
        this.fallbackFailed = true;
      }
    },
    handleEdit() {
      this.$emit('edit');
    },
    handleDelete() {
      this.$emit('delete');
    },
    openLink(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    async $handleApi() {
      if (this.api && typeof this.api === 'function') {
        await this.api();
      }
    }
  },
  computed: {
    ...mapState('user', ['user']),
    imageSource() {
      if (this.fallbackFailed) return '';
      if (this.imageFailed) return this.fallbackImage;
      return this.icon || this.fallbackImage;
    },
    validateOrganization() {
      return ['HEAD_OFFICE', 'BRANCH', 'ORGANIZATION_USER', 'ORGANIZATION'].includes(this.user.role);
    },
  },
};
</script>
<style scoped>
.benefit_title-sm {
  font-size: 13px;
}
.benefit_description {
  font-size: 14px;
}
.benefit_description-sm {
  font-size: 11px;
}

.format_paragraph {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
